import {GET_BASE_URL} from "../constants";

type UploadImageResult = { status: number; data: { c_file_name: string } };

const UPLOAD_FAILED_MESSAGE = 'Sorry, that photo could not be added. Please try again.';

/**
 * Uploads a photo for the post/comment editors. The backend requires a
 * signed-in member and only accepts real JPG/PNG/GIF/WebP files; when it
 * refuses, the member sees its reason and the editor inserts nothing.
 */
export const UploadImage = async (file: File): Promise<UploadImageResult> => {
    const formData = new FormData();
    formData.append('upload_img', file);

    const token = localStorage.getItem('token');
    let result: any = null;
    try {
        const response = await fetch(GET_BASE_URL + '/api/v1/uploadImage', {
            method: 'POST',
            headers: token ? { Authorization: `bearer ${token}` } : undefined,
            body: formData,
        });
        result = await response.json().catch(() => null);
        if (response.ok && result?.data?.c_file_name) {
            return result;
        }
    } catch {
        // Network failure: fall through to the generic message.
    }

    const message = typeof result?.data?.error === 'string' ? result.data.error : UPLOAD_FAILED_MESSAGE;
    window.alert(message);
    throw new Error(message);
};
